<template>
  <!-- Edit your profile -->
  <div class="box mb-5">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-snackbar
      v-model="snackbar"
      color="#161520"
      :timeout="6000"
      top
      multi-line
    >
      <span v-html="snackbarMessage"></span>
      <v-btn
        dark
        text
        :color="snackbarType === 'error' ? '#f12d57' : '#44d22d'"
        @click="snackbar = false"
      >
        {{ $t("ask-box.snackbar.btn-1") }}
      </v-btn>
    </v-snackbar>

    <v-layout
      d-block
      d-md-flex
      row
      ma-0
      align-center
      justify-space-between
      class="box-header"
    >
      <v-flex xs12>
        <h2 class="box-header-item mb-3 mb-md-0">{{ $t("colleague-box.title") }}</h2>
      </v-flex>
    </v-layout>

    <div class="box-content">
      <!-- <h2 class="mb-5">{{ $t("colleague-box.sub-title") }}</h2> -->
      <template v-if="staticContent && staticContent.length > 0">
        <template v-for="(content, index) in staticContent">
          <p v-if="content.text" :key="index">
            <pre v-html="content.text"></pre>
          </p>
        </template>
      </template>

      <v-list>
        <v-subheader
          v-text="$t('colleague-box.list-title')"
        ></v-subheader>

        <transition-group name="fade">
          <template v-for="(staff, index) in staffs">
            <v-divider
              v-if="index != 0"
              :key="index"
              inset
            ></v-divider>

            <v-list-item :key="staff.id" class="py-2">
              <!-- Avatar -->
              <v-list-item-avatar>
                <v-img :src="`${require('@/assets/images/profile-man.svg')}`"></v-img>
              </v-list-item-avatar>
              <!-- Content -->
              <v-list-item-content>
                <v-list-item-title v-html="staff.title"></v-list-item-title>
                <v-list-item-subtitle v-html="staff.address"></v-list-item-subtitle>
              </v-list-item-content>
              <!-- Icon -->
              <v-list-item-icon>
                <v-btn text small @click="dialog = true; toDeleteStaff = staff">
                  <v-icon color="error" size="11">icon-delete</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </transition-group>
      </v-list>

      <!-- Dialog delete colleague -->
      <v-dialog
        v-model="dialog"
        max-width="650"
      >
        <v-card class="ma-0">
          <v-card-title class="headline" v-html="`${$t('colleague-box.dialog.title')} ${toDeleteStaff ? toDeleteStaff.title : 'colleague'}`"></v-card-title>

          <v-card-text>
            {{ $t("colleague-box.dialog.description") }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              text
              color="error"
              @click="dialog = false"
            >
              {{ $t("colleague-box.dialog.btn-1") }}
            </v-btn>
            <v-btn
              outlined
              rounded
              color="primary"
              :disabled="!toDeleteStaff"
              @click="deleteColleague(toDeleteStaff.id)"
            >
              {{ $t("colleague-box.dialog.btn-2") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog><!-- Dialog delete firm -->

      <v-form
        v-model="valid"
        @submit.prevent="createColleague"
        class="mt-8"
      >
        <v-container>

          <!-- address -->
          <v-flex xs12>
            <v-text-field
              v-model="staffAddress"
              :label="$t('colleague-box.label-1')"
              outlined
              class="mandatory"
              required
              aria-required
              :rules="[rules.email]"
            ></v-text-field>
          </v-flex><!-- address -->

          <!-- city -->
          <v-flex xs12>
            <v-text-field
              v-model="staffName"
              :label="$t('colleague-box.label-2')"
              outlined
              class="mandatory"
              required
              aria-required
            ></v-text-field>
          </v-flex><!-- city -->

          <!-- submit -->
          <div class="text-center">
            <v-btn
              :elevation="0"
              rounded
              color="primary"
              type="submit"
              small
              v-html="$t('colleague-box.cta')"
              :disabled="staffAddress && emailReg.test(staffAddress) && staffName ? false : true"
            ></v-btn>
          </div>

        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { staffList } from '@/js/staff/staffList'
import { staffCreate } from '@/js/staff/staffCreate'
import { staffDelete } from '@/js/staff/staffDelete'
import { getStatic } from '@/js/static/getStatic'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    HTTPresponse: HTTPresponse
  },
  data () {
    return {
      valid: false,
      dialog: false,
      toDeleteStaff: null,

      staffs: null,
      staffAddress: null,
      staffName: null,

      emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      rules: {
        email: value => {
          if (value === '') return true
          const reg = this.emailReg
          return reg.test(value) || this.$t('rules-field.email')
        }
      },

      staticContent: null,

      httpalert: false,
      snackbar: false,
      snackbarMessage: this.$t('colleague-box.snackbar.title'),
      snackbarType: 'success'
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    staffList(this.$store.state.auth.token)
      .then(response => this.staffs = response)
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
      })
    
    const params = {
      lang: this.$i18n.locale ? this.$i18n.locale : 'en',
      keyword: 'colleaguebox'
    }
    getStatic(params)
      .then(response => this.staticContent = response.modules)
      // .catch(() => {
      //   this.httpalert = true
      //   setTimeout(() => {
      //     this.httpalert = false
      //   }, 4000)
      // })
  },

  methods: {
    createColleague () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const { staffAddress, staffName } = this
      const params = {
        address: staffAddress,
        id: '',
        title: staffName,
        key: this.$store.state.auth.token
      }
      staffCreate(params)
        .then(response => {
          if (response.data.status === 'ok' || response.data.status === 'OK') {
            // refresh staffs list
            staffList(this.$store.state.auth.token)
              .then(response => this.staffs = response)
              .catch(() => {
                this.httpalert = true
                setTimeout(() => {
                  this.httpalert = false
                }, 4000)
              })
            
            this.staffAddress = ''
            this.staffName = ''

            this.snackbar = true
          } else {
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          }
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    deleteColleague(staffId) {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        id: staffId,
        key: this.$store.state.auth.token
      }
      staffDelete(params)
        .then(response => {
          // refresh staffs list
          staffList(this.$store.state.auth.token)
            .then(response => this.staffs = response)
            .catch(() => {
              this.httpalert = true
              setTimeout(() => {
                this.httpalert = false
              }, 4000)
            })
          this.dialog = false
        })
        .catch(() => {
          this.dialog = false
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
